import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import logo from '../Assets/logo.png';
import cart_icon from '../Assets/cart_icon.png';
import { ShopContext } from '../../Context/ShopContext';

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const { getTotalCartAmount } = useContext(ShopContext);
    const [isAdmin, setIsAdmin] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const email = localStorage.getItem('user-email');
        if (email === 'admin123@email.com') {
            setIsAdmin(true);
        }
    }, []);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleLogout = () => {
        localStorage.removeItem('auth-token');
        localStorage.removeItem('user-email');
        navigate('/login');
        setIsAdmin(false);
    };

    return (
        <nav className='navbar'>
            <div className="nav-logo" onClick={() => navigate('/')}>
                <img src={logo} alt="Logo" /> 
            </div>
            <button className='nav-toggle' onClick={toggleMenu}>
                <span className='hamburger-icon'></span>
            </button>
            <ul className={`nav-menu ${menuOpen ? 'nav-menu-visible' : ''}`}>
                <li>
                    <a>
                        <Link to='/' onClick={toggleMenu}>Shop</Link>
                    </a>
                </li>
                <li>
                    <Link to='/cropped' onClick={toggleMenu}>Tops & Croppeds</Link>
                </li>
                <li>
                    <Link to='/bolsa' onClick={toggleMenu}>Bolsas</Link>
                </li>
                <li>
                    <Link to='/kit-banheiro' onClick={toggleMenu}>Kit de Banheiro</Link>
                </li>
                <li>
                    <Link to='/kit-cozinha' onClick={toggleMenu}>Kit de Cozinha</Link>
                </li>
                {isAdmin && (
                    <li>
                        <button onClick={() => window.location.href = 'https://ecommerce-croche-admin.vercel.app/'}>
                            Admin
                        </button>
                    </li>
                )}
                <li>
                    {localStorage.getItem('auth-token') ? (
                        <button onClick={handleLogout}>Logout</button>
                    ) : (
                        <Link to='/login'><button>Login</button></Link>
                    )}
                </li>
                <li>
                    <Link to='/cart'>
                        <img src={cart_icon} alt="Cart" />
                    </Link>
                    <div className="nav-cart-count">{getTotalCartAmount()}</div>
                </li>
            </ul>
        </nav>
    );
};

export default Navbar;
